import React from "react";

import clsx from "clsx";

import Image from "next/image";

import FigureImageMobile from "public/images/enerflo-solar-sales-platform-deals-page-mobile.png";
import FigureImage from "public/images/enerflo-solar-sales-platform-deals-page.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";

const title = "Sell Like You've Never Sold Before with Enerflo";
const imageAlt = "Enerflo Sales Core is the most unified solar sales process in the industry.";

const MainHero = () => (
  <div className="bg-gradient-to-b from-navy-dark to-primary">
    <HeroSection title={title} className="flex-col md:space-x-0 pb-0 sm:pb-0 lg:pb-0">
      <HeroSection.Content className="w-full md:max-w-[85%] lg:max-w-[70%] py-4 md:py-8 text-center text-white">
        <HeroSection.Header className="text-center">
          <Heading tag="h1" className="tracking-wide">
            {title}
          </Heading>
        </HeroSection.Header>
        <HeroSection.Description className="text-gray-100 leading-relaxed md:text-lg text-center">
          Close more deals on the one sales platform to rule them all. Onboard and train reps faster, increase
          efficiencies and reduce errors with Enerflo’s unified Sales Process.
        </HeroSection.Description>
      </HeroSection.Content>

      <figure className="w-full max-w-7xl">
        <div className="hidden xs:px-4 xs:block relative -bottom-px">
          <Image
            src={FigureImage}
            alt={imageAlt}
            layout="responsive"
            quality={100}
            placeholder="blur"
            loading="eager"
            priority
            className="crispImage"
          />
        </div>
        <div className={clsx(styles.maxHImageWrapper, "xs:hidden")}>
          <Image
            src={FigureImageMobile}
            alt={imageAlt}
            layout="responsive"
            quality={100}
            placeholder="blur"
            loading="eager"
            priority
            className="crispImage"
          />
        </div>
      </figure>
    </HeroSection>
  </div>
);

export default MainHero;
